const KeenSlider = window.KeenSlider
const { setInitialised } = window.BAO.Carousel.plugins

class PushCartRecs extends HTMLElement {
  constructor () {
    super()

    this.slider = null
    this.toggle = this.toggle.bind(this)
    this.addToCart = this.addToCart.bind(this)
    this.renderSection = this.renderSection.bind(this)
    this.renderVariantPicker = this.renderVariantPicker.bind(this)
    this.handleViewportChange = this.handleViewportChange.bind(this)
  }

  connectedCallback () {
    this.initializeElements()
    this.setupEventListeners()
  }

  initializeElements () {
    this.toggleEl = this.querySelector('[data-push-cart-recs-el="toggle"]')
    this.productBtns = this.querySelectorAll('[data-push-cart-recs-el="product-add"]')
    this.variantBtns = this.querySelectorAll('[data-push-cart-recs-el="variant-add"]')
    this.variantPickerEl = document.querySelector('[data-push-cart-recs-external-el="variant-picker"]')
    this.carouselEl = document.querySelector('[data-push-cart-recs-el="carousel"]')

    if (!KeenSlider) {
      return
    }

    if (!this.carouselEl) {
      return
    }

    this.slider = new KeenSlider(this.carouselEl, {
      slides: {
        perView: 1.75,
        spacing: 5,
      },
      breakpoints: {
        '(min-width: 460px)': {
          slides: {
            perView: 2,
            spacing: 5,
          },
        },
      }
    },
      [
        setInitialised(),
      ])
  }

  setupEventListeners () {
    if (this.toggleEl) {
      this.toggleEl.addEventListener('click', this.toggle)
    }

    const mq = window.matchMedia('(max-height: 850px)');
    mq.addEventListener('change', this.handleViewportChange);

    this.handleViewportChange(mq)

    this.productBtns.forEach(btn => {
      btn.addEventListener('click', this.addToCart)
    })

    // Handle variant picker
    this.variantBtns.forEach(btn => {
      btn.addEventListener('click', this.renderVariantPicker)
    })

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.renderSection);
  }

  toggle () {
    const expanded = this.getAttribute('aria-expanded') === 'true'
    this.setAttribute('aria-expanded', String(!expanded))
  }

  handleViewportChange(e) {
      if (e.matches) {
        this.setAttribute('aria-expanded', false)
      } else {
        this.setAttribute('aria-expanded', true)
      }
  }

  async renderVariantPicker (e) {
    const button = e.target.closest('[data-product-id]')
    const id = button.dataset.productId

    fetch(`${routes.products_url}/${id}/?section_id=section-variant-picker`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const source = html.querySelector('#variant-picker')
        this.variantPickerEl.innerHTML = source.innerHTML

        const innerVariantPicker = this.variantPickerEl.querySelector('variant-picker')
        innerVariantPicker.setAttribute('data-target', 'cart-recs')
      })
      .catch((e) => {
        console.error(e)
      })
  }

  removeVariantPicker() {
    this.variantPickerEl.innerHTML = ''
  }

  async renderSection () {
    this.removeVariantPicker()
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const source = html.querySelector('#cart-recs')
        this.innerHTML = source.innerHTML
      })
      .catch((e) => {
        console.error(e)
      })
  }

  async addToCart (e) {
    const button = e.target.closest('[data-variant-id]')
    const id = button.dataset.variantId

    if (id) {
      const body = JSON.stringify({
        items: [
          {
            quantity: 1,
            id,
          }
        ],
      })

      await fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), ...{ body } })
        .then((response) => {
          return response.text()
        })
        .then((state) => {
          const parsedState = JSON.parse(state)
          publish(PUB_SUB_EVENTS.cartUpdate, { source: `${this.dataset.target}`, cartData: parsedState, variantId: id })
        })
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

}

if (!customElements.get('push-cart-recs')) {
  customElements.define('push-cart-recs', PushCartRecs)
}
